module.exports = __webpack_public_path__ + "static/media/host.33e38274.png";